var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.3335 11.3397L5.34016 11.3323",
  stroke: "#131927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33333 3.33301H2.4C2.17909 3.33301 2 3.51209 2 3.73301V13.5997C2 13.8206 2.17909 13.9997 2.4 13.9997H8.26667C8.48758 13.9997 8.66667 13.8206 8.66667 13.5997V10.6663",
  stroke: "#131927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6665 2L10.6665 8.66667",
  stroke: "#131927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.6665 3.33301L8.6665 7.33301",
  stroke: "#131927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6665 4.66699L14.6665 6.00033",
  stroke: "#131927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.6665 4.66699L6.6665 6.00033",
  stroke: "#131927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6665 2.66699L12.6665 8.00033",
  stroke: "#131927",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default __webpack_public_path__ + "static/media/AudioRec.00bf4f2c.svg";
export { SvgComponent as ReactComponent };